<script setup>
import MazPhoneNumberInput from 'maz-ui/components/MazPhoneNumberInput'
import {onBeforeMount, ref} from 'vue';
import TextInput from "@/Components/TextInput.vue";
import InputLabel from "@/Components/InputLabel.vue";
import {mask} from 'vue-the-mask';

let vMask = mask;

const props = defineProps({
  modelValue: String,
});
const emit = defineEmits(['update:modelValue']);
const phoneNumber = ref('');
const extension = ref('');
const results = ref(null);
const countryCode = ref('US');
const vModel = ref(props.modelValue);

onBeforeMount(() => {
  if (!props.modelValue) {
    return;
  }
  if (props.modelValue.startsWith('+')) {
    countryCode.value = null;
  }
  const chunks = props.modelValue.split(', Ext: ');
  phoneNumber.value = chunks[0] || '';
  extension.value = chunks[1] || '';
});
const update = (event, extensionValue = null) => {
  console.log('UPDATE EVENT');
  results.value = event;
  extension.value = extensionValue;
  phoneNumber.value = results.value.formatInternational;
  extension.value = extensionValue;
  if (results.value.isValid) {
    let value = phoneNumber.value;
    if (extensionValue !== '') {
      value += `, Ext: ${extensionValue}`
    }

    emit('update:modelValue', value);
  }
}

</script>

<template>
  <div class="grid grid-cols-6 gap-2">
    <div class="col-span-4">
      <InputLabel value="Phone"/>
      <MazPhoneNumberInput
        :model-value="phoneNumber"
        :show-code-on-list="true"
        :default-country-code="countryCode"
        :preferred-countries="['US']"
        v-model="vModel"
        @update="update($event, extension)"
        :error="phoneNumber && !results?.isValid"
      />
    </div>
    <div class="col-span-2">
      <InputLabel for="extension" value="Ext."/>
      <TextInput
        v-mask="'#####'"
        id="extension"
        :value="extension"
        type="text"
        class="mt-1 w-full"
        @input="update(results, $event.target.value)"
      />
    </div>
  </div>
</template>
